<mat-form-field class="comments">
  <mat-label>Kommentarer</mat-label>
  <textarea [formControl]="comments" cdkTextareaAutosize matInput></textarea>
</mat-form-field>
